// Helpers puros da feature "Cliente estrangeiro" no modal Novo Check-in.
// Extraídos para permitir teste unitário do comportamento (auto-detecção, limpeza,
// layout condicional e documentType), sem montar o modal inteiro.

import {
    clearedFieldsOnToggle,
    detectForeigner,
    foreignDocumentFields,
    nationalDocumentFields,
} from '../../helpers/foreigner-helper'; // relativo: o alias ~ nao resolve no jest do CRA

// `detectForeigner` e `clearedFieldsOnToggle` subiram para `helpers/foreigner-helper`
// porque o cadastro de pessoas passou a usar as mesmas regras (AD-010). Reexportados
// aqui para não quebrar quem já importa deste módulo.
export { clearedFieldsOnToggle, detectForeigner };

// Campos que devem aparecer no topo (identificação) conforme o estado da flag.
export const topDocumentFields = isForeigner => (
    isForeigner ? foreignDocumentFields() : nationalDocumentFields()
);

// Campos do bloco "Mais informações" (complementar ao topo, sem interseção).
export const moreInfoDocumentFields = isForeigner => (
    isForeigner ? [] : foreignDocumentFields()
);

// documentType do payload: estrangeiro => 1 ("Outro Documento"); senão mantém o
// tipo selecionado (fallback 0 = CPF).
export const resolveDocumentType = (values = {}) => (
    values.isForeigner ? 1 : (values.documentType?.item?.key ?? 0)
);

// O que ainda falta para o Salvar ficar habilitado, em texto, na ordem da tela (AD-011).
//
// Existe para que o botão nunca fique cinza sem explicação: era assim que o bloqueio de
// anfitrião empurrava as pessoas a ligarem o toggle "Anfitrião", marcando o VISITANTE
// como anfitrião do prédio só para conseguir salvar.
//
// A exigência GLOBAL de associação (`checkinAssociationType`) não entra aqui — deixou de
// bloquear em AD-011. O `needsHost`/`needsCompany` do grupo continua valendo, porque é
// escolha explícita que o cliente fez por grupo na tela de configuração, e `isHost`
// dispensa a associação: quem é anfitrião não precisa de outro.
export const saveBlockers = ({
    hasName, hasAnyDocument, hasGroup, hasPhoto, hasHost, hasCompany, isHost, group,
} = {}) => {
    const blockers = [];

    if (!hasName) blockers.push('nome');
    if (!hasAnyDocument) blockers.push('documento');
    if (!hasGroup) blockers.push('grupo');
    if (!hasPhoto) blockers.push('foto');

    if (!isHost) {
        if (group?.needsHost && !hasHost) blockers.push('anfitrião (exigido pelo grupo)');
        if (group?.needsCompany && !hasCompany) blockers.push('empresa (exigida pelo grupo)');
    }

    return blockers;
};

// Deriva de saveBlockers de propósito: duas listas de regras em paralelo divergiriam.
export const canSaveCheckin = state => saveBlockers(state).length === 0;
